import Page from 'component/Page';
import { useEffect, useMemo } from 'react';
import { useState } from 'react';
import { sendPost, sendPut } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
// import UserMaintenance from './UserMaintenance';
import UserAdd from './UserAdd';
import UserUpdate from './UserUpdate';
import UserIdUpdate from './UserIdUpdate';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import {
  ACCOUNT_ROLE_ADMIN,
  // ACCOUNT_ROLE_PARENT,
} from 'util/permission';
import { useCallback } from 'react';
import {
  formatDate,
  nNU,
  showConfirm,
  showToast,
  hideToast
  // getString,
} from 'util/utils';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

export const accountRoleNameMap = {
  0: string.ACCOUNT_ROLE_ADMIN,
  1: string.ACCOUNT_ROLE_NORMAL,
  2: string.ACCOUNT_ROLE_MONITOR,
};

export const accountStatusNameMap = {
  true: string.ACTIVE,
  false: string.INACTIVE,
};

const UserList = () => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const currentUser = useSelector(selectCurrentUser);
  const [ users, setUsers ] = useState([]);
  const [ page, setPage ] = useState(1);
  const [ total, setTotal ] = useState(0);
  const [ pageSize, setPageSize ] = useState(10);
  const [ searchId, setSearchId ] = useState('');
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [ currentUser.accountRole ]
  );
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [ currentUser.isMonitorOnly ]
  );
  const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);

  const [ selectedUser, setSelectedUser ] = useState(null);
  const [ addUser, setAddUser ] = useState(null);
  const [ addUserId, setAddUserId ] = useState(null);
  const history = useHistory();

  //------------------------FUNCTIONS----------------------------------------------------------
  const doSearch = useCallback(
    async (page, pageSize, searchKeyword, getAll = false) => {
      let data = await sendPost({
        url: Urls.admin.list,
        body: {
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: searchKeyword,
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setUsers(result);
        setTotal(total);
      }
      return result;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ currentUser ]
  );

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchId(searchId);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [ searchId ]);
  useEffect(() => {
    const hideToasts = () => {
      hideToast()
    };
    const timerId = setTimeout(hideToasts, 6000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    doSearch(page, pageSize, debouncedSearchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ page, pageSize, debouncedSearchId, doSearch ]);

  const dataTable = useCallback(
    (data) =>
      // data.sort((a,b) => Number(b.totalChildAccount)-Number(a.totalChildAccount)).map((raw, key) => ({
      data.map((raw, key) => ({
        key: raw.id,
        data: [
          !!nNU(raw.customerId) ? raw.customerId : '-',
          raw.email,
          raw.usernameKanji,
          raw.usernameHira,
          raw.phoneNumber,
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{`${raw.email}のアプリID一覧へ`}</Tooltip>}
          >
            <Button
              style={{
                padding: '4px',
                minWidth: '4.5em',
                display: 'flex',
                justifyContent: 'center',
              }}
              id={raw.id}
              onClick={(e) => onAppIdClick(e)}
            >
              {raw.totalChildAccount}
            </Button>
          </OverlayTrigger>,
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{`${raw.email}のシークレットCH一覧へ`}</Tooltip>}
          >
            <Button
              style={{
                padding: '4px',
                minWidth: '4.5em',
                display: 'flex',
                justifyContent: 'center',
              }}
              id={raw.id}
              onClick={(e) => onAppChClick(e)}
            >
              {raw.totalChildGroup}
            </Button>
          </OverlayTrigger>,
          // raw.totalChildGroupActive,
          formatDate(raw.createdAt, 'YYYY/MM/DD'),
        ],
        raw,
      })),
    []
  );
  const mainActions = isMonitorOnly
    ? []
    : [
      {
        icon: 'add',
        title: string.NEW_ACCOUNT,
        onClick: () => setAddUser({ valid: true }),
      },
    ];
  const actions = isMonitorOnly
    ? []
    : [
      ({ raw }) => {
        if (raw.status === 0) {
          return {
            render: 'edit',
            onClick: ({ raw }) => setSelectedUser(raw),
          };
        }
      },
      ({ raw }) => {
        if (raw.status === 0) {
          return {
            render: 'customerid',
            onClick: ({ raw }) => setAddUserId(raw),
          };
        }
      },
      ({ raw }) => {
        if (raw.status !== 0) {
          return;
        }
        if (raw.banned !== 1) {
          return {
            render: 'ban',
            className: 'color-danger',
            onClick: ({ raw }) => {
              let banData = {
                id: raw.id,
                ban: true,
              };
              showConfirm({
                body: string.ACCOUNT_DELETE_CONFIRM,
                defaultAction: () => {
                  sendPut({
                    url: Urls.admin.ban,
                    body: banData,
                  })
                    .then((res) => {
                      showToast(string.ACCOUNT_DELETE_SUCCESS, 'success');
                      doSearch(page, pageSize);
                    })
                    .catch((e) => {
                      console.log('削除エラー');
                    });
                },
              });
            },
          };
        } else {
          return {
            render: 'approve',
            onClick: ({ raw }) => {
              let banData = {
                id: raw.id,
                ban: false,
              };
              showConfirm({
                body: string.ACCOUNT_APPROVE_CONFIRM,
                defaultAction: () => {
                  sendPut({
                    url: Urls.admin.ban,
                    body: banData,
                  })
                    .then((res) => {
                      showToast(string.ACCOUNT_APPROVE_SUCCESS, 'success');
                      doSearch(page, pageSize);
                    })
                    .catch((e) => {
                      console.log('削除エラー');
                    });
                },
              });
            },
          };
        }
      },
    ];
  const onAppIdClick = (e) => {
    let id = e.currentTarget.id;
    // console.log(id);
    history.push(`${Paths.user.details}/?id=${id}&tab=appids`);
  };
  const onAppChClick = (e) => {
    let id = e.currentTarget.id;
    // console.log(id);
    history.push(`${Paths.user.details}/?id=${id}&tab=appchannels`);
  };

  //------------------------------------RETURN---------------------------------------------------------
  return (
    <>
      <Page
        title={string.ACCOUNT_MANAGEMENT}
        body={
          <>
            <Table
              className="nowrap"
              mainActions={mainActions}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={[
                string.ACCOUNT_CUSTOMER_ID,
                string.ACCOUNT_MAIL,
                string.ACCOUNT_NAME_KANJI,
                string.ACCOUNT_NAME_HIRA,
                string.PHONE_NUMBER,
                string.APP_ID,
                string.APP_SECRET_CHANNEL,
                string.REGISTER_DATE,
              ]}
              data={dataTable(users)}
              getCSVData={!isMonitorOnly && (async () => {
                return dataTable(await doSearch(1, total, null, true));
              })}
              csvFileName="AccountList"
              actions={actions}
              search={true}
              onSearch={(value) => setSearchId(value)}
              placeHolder={`${string.EMAIL_ADDRESS}`}
            />
          </>
        }
      />
      <Modal
        show={!!selectedUser}
        onHide={() => setSelectedUser(null)}
        body={
          <>
            {!!selectedUser && (
              <UserUpdate
                onUpdated={() => {
                  setSelectedUser(null);
                  doSearch(page, pageSize);
                }}
                data={selectedUser}
              />
            )}
          </>
        }
      />
      <Modal
        show={!!addUser}
        onHide={() => setAddUser(null)}
        body={
          <>
            {!!addUser && (
              <UserAdd
                onUpdated={() => {
                  setAddUser(null);
                  doSearch(page, pageSize);
                }}
                data={addUser}
              />
            )}
          </>
        }
      />
      <Modal
        show={!!addUserId}
        onHide={() => setAddUserId(null)}
        body={
          <>
            {!!addUserId && (
              <UserIdUpdate
                onUpdated={() => {
                  setAddUserId(null);
                  doSearch(page, pageSize);
                }}
                data={addUserId}
              />
            )}
          </>
        }
      />
    </>
  );
};

export default UserList;
